import React from 'react';
import AppModal from '../CustomModal';
import { ToSnakeCase } from 'components/atoms/CaseManager';
import useNavData from 'components/molecules/navData';
import NavItem from 'components/atoms/NavItem';
import ViewSwitcher from 'components/atoms/ViewSwitcher';
import SocialLinks from '../Footer/SocialLinks';
import { connect } from 'react-redux';

interface NavModalProps {
    setModalState: (state: boolean) => void;
    sectionInView?: string;
}

const NavModal: React.FC<NavModalProps> = (props) => {
    const { navItems } = useNavData();

    const navItemFunc = (item: { navItem: string; hidden?: boolean; available: boolean; path: string }, index: number) => {
        return (
            <NavItem
                key={index}
                sectID={item.navItem}
                navItem={item.navItem}
                hidden={item.hidden}
                available={item.available}
                active={ToSnakeCase(item.navItem) === ToSnakeCase(props.sectionInView || '')}
                navLink={item.path}
                onClick={() => props.setModalState(false)}
                action={null}
                variant="row"
                setModalState={props.setModalState}
            />
        );
    };

    return (
        <AppModal
            handleClose={() => props.setModalState(false)}
            ariaLabel="Site navigation"
            panelId="mobile-nav-panel"
            modalStyle="border border-NoColor bg-DarkBg2 hover:border-Primary w-2/5 mobile:w-[90%] max-w-[320px] z-30 right-0 left-0 top-20 mx-auto max-h-[calc(100vh-6rem)] overflow-y-auto overscroll-contain rounded-lg mobile:rounded-lg shadow-[0_8px_30px_rgb(0,0,0,0.12)] animate-slide_down2 mobile:animate-fade_in transition ease-in-out duration-500"
            backDropStyle='!bg-BackDrop_d_xl'
            contentStyle="p-5 mobile:p-4 pt-12 mobile:!pt-12 flex flex-col gap-4"
            closeBtnStyle='text-Primary'
        >
            <nav
                aria-label="Sections"
                className='w-full flex flex-col gap-1'
                style={{ background: 'var(--site-bg-nav)' }}
            >
                {navItems.map((item, i) => navItemFunc(item, i))}
            </nav>

            <ViewSwitcher wrapperStyle='w-full justify-center flex-shrink-0' onNavigate={() => props.setModalState(false)} />

            <SocialLinks
                wrapperStyle='!border-none !p-0 mobile:!py-0'
                iconWrapperStyle='!justify-evenly w-full'
                iconStyle='!w-5 !h-5 !text-Primary'
                social
            />
        </AppModal>
    );
};

const mapStateToProps = (state: { app: { sectionInView: string } }) => ({
    sectionInView: state.app.sectionInView
});

export default connect(mapStateToProps)(NavModal);
